module.exports = __webpack_public_path__ + "img/confirm.4084d889.svg";